_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[49],{

/***/ "/svJ":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"_2-X7Md","transparent":"_2GugVo","no":"_2GUTBL","title":"_2KvYvc","roundIcon":"_2GKmvF","roundIconOwner":"cv_JdY","tooltip":"_8-No2n","tooltipContent":"_1ilRsp","left":"_3kHYBk","noDocumentTitle":"_1GLPAt","bothDocumentHave":"_1WQsyL","disable":"_2lucyi","card":"_2yW_oR","right":"LpUwES","center":"_1WVsyo","tooltipSpace":"_31BvU-"};

/***/ }),

/***/ "5adZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/async/dist/async.js
var dist_async = __webpack_require__("cfFl");
var async_default = /*#__PURE__*/__webpack_require__.n(dist_async);

// EXTERNAL MODULE: ./services/account.js
var services_account = __webpack_require__("NyAi");

// CONCATENATED MODULE: ./src/utils/agent/index.js
var isValidAgentUrl = function isValidAgentUrl(asPath, listing) {
  // eslint-disable-next-line no-use-before-define
  var queryPart = splitUrls(asPath);
  var url = listing && listing.url;
  return url === queryPart;
};

function splitUrls(asPath) {
  var isHaveQueryParams = asPath.includes('?');
  var withOutQueryParams = isHaveQueryParams ? asPath.split('?')[0] : asPath;
  var queryPart = withOutQueryParams.split('emlak-ofisleri-detay')[1].split('/')[1];
  return "/emlak-ofisleri-detay/".concat(queryPart);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__("KQm4");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("vuIU");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js + 1 modules
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__("g4pe");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__("mOvS");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/shortid/index.js
var shortid = __webpack_require__("je4i");
var shortid_default = /*#__PURE__*/__webpack_require__.n(shortid);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./src/redux-store/containers/favorites/index.js + 1 modules
var favorites = __webpack_require__("FWZ+");

// EXTERNAL MODULE: ./src/helpers/capitalize-letter/index.js
var capitalize_letter = __webpack_require__("OXD+");

// EXTERNAL MODULE: ./src/helpers/notifier/index.js
var notifier = __webpack_require__("Z0GP");

// EXTERNAL MODULE: ./src/helpers/image-url-maker/index.js + 4 modules
var image_url_maker = __webpack_require__("1Vvl");

// EXTERNAL MODULE: ./src/components/pures/datef/index.js
var datef = __webpack_require__("ye2T");

// EXTERNAL MODULE: ./src/utils/number-formatter/index.js
var number_formatter = __webpack_require__("BF7R");
var number_formatter_default = /*#__PURE__*/__webpack_require__.n(number_formatter);

// CONCATENATED MODULE: ./src/components/desktop/price/index.jsx
var __jsx = react_default.a.createElement;



var price_Price = function Price(_ref) {
  var price = _ref.data;
  if (!price) return null;
  var alternativeValue = price.alternativeValue == null ? '' : price.alternativeValue;
  var visiblePrice = price.price == null ? alternativeValue : number_formatter_default.a.format(price.price);
  var visiblePriceCurrency = price.price === null ? '' : price.currency;
  return __jsx("span", null, "".concat(visiblePrice, " ").concat(visiblePriceCurrency));
};

/* harmony default export */ var desktop_price = (price_Price);
// EXTERNAL MODULE: ./src/components/pures/location/index.js
var pures_location = __webpack_require__("mOBv");

// EXTERNAL MODULE: ./src/utils/image/index.js
var utils_image = __webpack_require__("uO9N");

// EXTERNAL MODULE: ./src/helpers/listing/card/index.js + 2 modules
var card = __webpack_require__("sAgW");

// EXTERNAL MODULE: ./src/components/desktop/elements/index.js + 12 modules
var desktop_elements = __webpack_require__("9aJQ");

// EXTERNAL MODULE: ./src/components/desktop/elements/badge/badge-card-e6t/index.jsx
var badge_card_e6t = __webpack_require__("cA7+");

// EXTERNAL MODULE: ./src/components/e6t/lazy-image/index.jsx
var lazy_image = __webpack_require__("eM4/");

// EXTERNAL MODULE: ./src/components/desktop/widgets/featured-listing-item-search/styles.module.scss
var styles_module = __webpack_require__("YAe4");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("ODXe");

// EXTERNAL MODULE: ./src/components/desktop/favorites/index.jsx + 12 modules
var desktop_favorites = __webpack_require__("xKmG");

// EXTERNAL MODULE: ./src/components/desktop/listing-detail/listing-detail-owner-widget/show-phone/index.jsx
var show_phone = __webpack_require__("+vld");

// EXTERNAL MODULE: ./src/components/desktop/compare/button/index.jsx
var compare_button = __webpack_require__("o58N");

// EXTERNAL MODULE: ./src/utils/constants/trade-types.js
var trade_types = __webpack_require__("qpzi");

// EXTERNAL MODULE: ./src/utils/constants/categories.js
var categories = __webpack_require__("woo7");

// EXTERNAL MODULE: ./src/helpers/google-tag-manager/events.js
var events = __webpack_require__("tkT3");

// EXTERNAL MODULE: ./src/helpers/google-tag-manager/events/listing-detail.js
var listing_detail = __webpack_require__("UYDH");

// CONCATENATED MODULE: ./src/components/desktop/widgets/featured-listing-item-search/hover-buttons/index.jsx


var hover_buttons_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var hover_buttons_HoverButtons = function HoverButtons(_ref) {
  var listing = _ref.listing,
      gtmEventLabel = _ref.gtmEventLabel,
      itemIndex = _ref.itemIndex,
      pageNumber = _ref.pageNumber;

  var _React$useState = react_default.a.useState({
    loading: false,
    compareVisible: false,
    favoritePopper: false
  }),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      states = _React$useState2[0],
      setStates = _React$useState2[1];

  var tradeType = lodash_default.a.get(listing, 'tradeTypeName', undefined);

  var category = lodash_default.a.get(listing, 'categoryTypeName', undefined);

  var listingPrice = lodash_default.a.get(listing, 'priceDetail', undefined);

  var showButtons = function showButtons(state) {
    setStates(_objectSpread(_objectSpread({}, states), {}, {
      favoritePopper: state
    }));
  };

  var handleLinkClick = function handleLinkClick(event) {
    var _listing$badges;

    if (listing === null || listing === void 0 ? void 0 : (_listing$badges = listing.badges) === null || _listing$badges === void 0 ? void 0 : _listing$badges.includes('promotion')) {
      Object(listing_detail["handleAgentDetailGTMEvent"])(event, listing, itemIndex, pageNumber, 'ilan-gorsel');
      Object(events["k" /* featuredListingsGTMEvents */])({
        label: itemIndex + 1
      });
    } else {
      Object(listing_detail["handleAgentDetailGTMEvent"])(event, listing, itemIndex, pageNumber, 'ilan-gorsel');
    }
  };

  return hover_buttons_jsx("div", {
    className: styles_module_default.a.featuredListingWrapper,
    style: states.favoritePopper ? {
      backgroundImage: 'linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #fff 70%)'
    } : {}
  }, hover_buttons_jsx("a", {
    href: listing.url,
    className: styles_module_default.a.link,
    onClick: function onClick(event) {
      return handleLinkClick(event);
    }
  }), hover_buttons_jsx("div", {
    className: styles_module_default.a.featuredListingWrapperButtons,
    style: states.favoritePopper ? {
      visibility: 'visible'
    } : {}
  }, tradeType === trade_types["a" /* default */].SALE.name && category === categories["a" /* default */].KONUT.name || tradeType === trade_types["a" /* default */].RENT.name && category === categories["a" /* default */].KONUT.name || tradeType === trade_types["a" /* default */].DAILY_RENT.name && category === categories["a" /* default */].KONUT.name ? hover_buttons_jsx(compare_button["a" /* default */], {
    listing: listing,
    home: true,
    style: {
      marginBottom: 8
    },
    gtmEventLabel: gtmEventLabel
  }) : null, hover_buttons_jsx(desktop_favorites["a" /* default */], {
    listingId: listing.id,
    favoritePopper: states.favoritePopper,
    hoverVisible: showButtons,
    type: "dynamic",
    position: "bottom-start",
    style: {
      marginBottom: 8
    },
    gtmEventLabel: gtmEventLabel,
    listingItem: listing,
    itemIndex: itemIndex,
    pageNumber: pageNumber
  }), hover_buttons_jsx(show_phone["a" /* default */], {
    listingOwnerPhone: listing.phoneNumber,
    clearPhoneNumber: true,
    listingId: listing.id,
    style: {
      marginBottom: 8
    },
    gtmEventLabel: gtmEventLabel,
    listing: listing,
    itemIndex: itemIndex,
    pageNumber: pageNumber,
    price: listingPrice
  })));
};

/* harmony default export */ var hover_buttons = (hover_buttons_HoverButtons);
// CONCATENATED MODULE: ./src/components/desktop/widgets/featured-listing-item-search/index.jsx





var featured_listing_item_search_jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
















var featured_listing_item_search_FeaturedListingItem = /*#__PURE__*/function (_React$PureComponent) {
  Object(inherits["a" /* default */])(FeaturedListingItem, _React$PureComponent);

  var _super = _createSuper(FeaturedListingItem);

  function FeaturedListingItem() {
    Object(classCallCheck["a" /* default */])(this, FeaturedListingItem);

    return _super.apply(this, arguments);
  }

  Object(createClass["a" /* default */])(FeaturedListingItem, [{
    key: "render",
    value: function render() {
      var _criteria$category, _criteria$category$tr;

      var _this$props = this.props,
          listing = _this$props.listing,
          searchParams = _this$props.searchParams,
          _this$props$criteria = _this$props.criteria,
          criteria = _this$props$criteria === void 0 ? {} : _this$props$criteria,
          gtmEventLabel = _this$props.gtmEventLabel,
          itemIndex = _this$props.itemIndex,
          pageNumber = _this$props.pageNumber;
      var decodedPhoto = Object(utils_image["a" /* decodeImage */])(listing.coverPhotoFull || (listing === null || listing === void 0 ? void 0 : listing.images[0]));
      var coverPhotoUrl = image_url_maker["a" /* default */].scaleImage(decodedPhoto, {
        width: 600,
        height: 338
      }, false);

      var town = lodash_default.a.get(listing, 'location.town', undefined);

      var district = lodash_default.a.get(listing, 'location.district', undefined);

      var quickInfoLine = card["a" /* default */].getConvertedQuickInfoE6t(listing);
      var quickInfoSet = card["a" /* default */].getCardIcons(quickInfoLine);
      var tradeTypeFloor = (criteria === null || criteria === void 0 ? void 0 : (_criteria$category = criteria.category) === null || _criteria$category === void 0 ? void 0 : (_criteria$category$tr = _criteria$category.tradeType) === null || _criteria$category$tr === void 0 ? void 0 : _criteria$category$tr.name) === 'Kat Karşılığı';

      var badges = lodash_default.a.get(listing, 'badges', undefined);

      return featured_listing_item_search_jsx("div", {
        className: styles_module_default.a.featuredListing
      }, featured_listing_item_search_jsx(hover_buttons, {
        listing: listing,
        gtmEventLabel: gtmEventLabel,
        itemIndex: itemIndex,
        pageNumber: pageNumber
      }), featured_listing_item_search_jsx("a", {
        href: listing.url,
        className: styles_module_default.a.link
      }, featured_listing_item_search_jsx("div", {
        className: styles_module_default.a.badges
      }, badges && badges.map(function (type, index) {
        return index < 2 && featured_listing_item_search_jsx(badge_card_e6t["a" /* default */], {
          key: shortid_default.a.generate(),
          type: type
        });
      })), featured_listing_item_search_jsx("div", {
        className: styles_module_default.a.listingImageContent
      }, featured_listing_item_search_jsx(lazy_image["a" /* default */], {
        src: coverPhotoUrl,
        placeholder: "/static/img/1px-transparent.png",
        alt: listing.title
      })), featured_listing_item_search_jsx("div", {
        className: styles_module_default.a.listingDetail
      }, featured_listing_item_search_jsx("div", {
        className: styles_module_default.a.listingDetailTitle
      }, featured_listing_item_search_jsx("span", null, listing.title)), featured_listing_item_search_jsx("p", {
        className: styles_module_default.a.listingDetailAdress
      }, featured_listing_item_search_jsx(pures_location["a" /* default */], {
        town: town,
        district: district,
        format: "{town} / {district}"
      })), featured_listing_item_search_jsx("div", {
        className: styles_module_default.a.listingDetailProperties
      }, quickInfoSet.length > 0 && quickInfoSet.map(function (qi) {
        return featured_listing_item_search_jsx("span", {
          key: shortid_default.a.generate()
        }, featured_listing_item_search_jsx(desktop_elements["e" /* Icon */], {
          name: qi.icon
        }), qi.value);
      })), featured_listing_item_search_jsx("div", {
        className: styles_module_default.a.listingDetailPriceAndDate
      }, featured_listing_item_search_jsx("p", {
        className: styles_module_default.a.price
      }, listing.priceDetail && featured_listing_item_search_jsx(desktop_price, {
        data: listing.priceDetail
      }), tradeTypeFloor && 'Kat Karşılığı'), featured_listing_item_search_jsx("p", {
        className: styles_module_default.a.date
      }, featured_listing_item_search_jsx(desktop_elements["e" /* Icon */], {
        name: "event"
      }), featured_listing_item_search_jsx("span", null, featured_listing_item_search_jsx(datef["a" /* default */], {
        format: "D MMMM",
        value: listing.createdAt
      })))))));
    }
  }]);

  return FeaturedListingItem;
}(react_default.a.PureComponent);

/* harmony default export */ var featured_listing_item_search = (featured_listing_item_search_FeaturedListingItem);
// EXTERNAL MODULE: ./src/components/desktop/listing/pagination-wrapper-e6t/index.jsx + 2 modules
var pagination_wrapper_e6t = __webpack_require__("KNLf");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@material-ui/core/styles/index.js
var styles = __webpack_require__("SUMQ");

// EXTERNAL MODULE: ./node_modules/@material-ui/core/ClickAwayListener/index.js
var ClickAwayListener = __webpack_require__("+qgJ");
var ClickAwayListener_default = /*#__PURE__*/__webpack_require__.n(ClickAwayListener);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/Grow/index.js
var Grow = __webpack_require__("dfx+");
var Grow_default = /*#__PURE__*/__webpack_require__.n(Grow);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/Paper/index.js
var Paper = __webpack_require__("pPbJ");
var Paper_default = /*#__PURE__*/__webpack_require__.n(Paper);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/Popper/index.js
var Popper = __webpack_require__("0cs1");
var Popper_default = /*#__PURE__*/__webpack_require__.n(Popper);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/MenuItem/index.js
var MenuItem = __webpack_require__("n5s8");
var MenuItem_default = /*#__PURE__*/__webpack_require__.n(MenuItem);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/MenuList/index.js
var MenuList = __webpack_require__("/ELG");
var MenuList_default = /*#__PURE__*/__webpack_require__.n(MenuList);

// CONCATENATED MODULE: ./__mock__/orderFilters.js
/* harmony default export */ var orderFilters = ([{
  value: 1,
  label: 'Akıllı Sıralama'
}, {
  value: 2,
  label: 'Fiyat: Önce En Yüksek'
}, {
  value: 3,
  label: 'Fiyat: Önce En Düşük'
}, {
  value: 4,
  label: 'Tarih: Önce En Yeni'
}]);
// EXTERNAL MODULE: ./services/url-maker.js
var url_maker = __webpack_require__("JirP");

// EXTERNAL MODULE: ./src/helpers/url/index.js
var helpers_url = __webpack_require__("gjsy");

// CONCATENATED MODULE: ./src/app/desktop/agent-page/e6t/order-dropdown/index.jsx




var order_dropdown_this = undefined;

var order_dropdown_jsx = react_default.a.createElement;

function order_dropdown_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function order_dropdown_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { order_dropdown_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { order_dropdown_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








 // eslint-disable-next-line import/no-unresolved






var order_dropdown_styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      marginBottom: 20
    },
    paper: {
      marginRight: theme.spacing.unit * 2
    },
    popper: {
      zIndex: 100
    }
  };
};

var order_dropdown_OrderDropdownE6t = function OrderDropdownE6t(_ref) {
  var criteria = _ref.criteria,
      classes = _ref.classes,
      buttonType = _ref.buttonType;

  var _React$useState = react_default.a.useState(null),
      _React$useState2 = Object(slicedToArray["a" /* default */])(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var _React$useState3 = react_default.a.useState(false),
      _React$useState4 = Object(slicedToArray["a" /* default */])(_React$useState3, 2),
      open = _React$useState4[0],
      setOpen = _React$useState4[1];

  var _React$useState5 = react_default.a.useState({}),
      _React$useState6 = Object(slicedToArray["a" /* default */])(_React$useState5, 2),
      currentValue = _React$useState6[0],
      setCurrentValue = _React$useState6[1];

  var handleToggle = function handleToggle() {
    setOpen(!open);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  };

  var onOptionChange = function onOptionChange(value) {
    delete criteria.pagination;
    var newOrder = {
      order: {
        orderType: Number(value)
      }
    };

    var newCriteria = order_dropdown_objectSpread(order_dropdown_objectSpread({}, criteria), newOrder);

    Object(url_maker["a" /* urlMaker */])({
      criteria: newCriteria
    }).then(function (res) {
      window.location = Object(helpers_url["g" /* normalizeUrl */])(res.data.path);
    });
  };

  react_default.a.useEffect(function () {
    if (criteria.order) {
      var orderValue = criteria.order.value || criteria.order.orderType;
      var value = orderFilters.filter(function (o) {
        return o.value === orderValue;
      });
      setCurrentValue(value[0]);
    }
  }, []);
  return order_dropdown_jsx("div", {
    className: classes.root
  }, order_dropdown_jsx(desktop_elements["b" /* Button */], {
    transparent: true,
    buttonRef: function buttonRef(node) {
      setAnchorEl(node);
    },
    "aria-owns": open ? 'menu-list-grow' : undefined,
    "aria-haspopup": "true",
    onClick: handleToggle,
    tertiary: true
  }, order_dropdown_jsx("div", {
    style: {
      display: 'flex',
      flexDirection: 'row'
    }
  }, (currentValue === null || currentValue === void 0 ? void 0 : currentValue.label) || 'Akıllı Sıralama', order_dropdown_jsx(desktop_elements["e" /* Icon */], {
    name: "expand_more"
  }))), order_dropdown_jsx(Popper_default.a, {
    open: open,
    anchorEl: anchorEl,
    transition: true,
    disablePortal: true,
    className: classes.popper,
    style: {
      zIndex: 100
    },
    placement: "bottom-end"
  }, function (_ref2) {
    var TransitionProps = _ref2.TransitionProps,
        placement = _ref2.placement;
    return order_dropdown_jsx(Grow_default.a, Object(esm_extends["a" /* default */])({}, TransitionProps, {
      id: "menu-list-grow",
      style: {
        transformOrigin: placement === 'bottom' ? 'center bottom' : 'center bottom'
      }
    }), order_dropdown_jsx(Paper_default.a, null, order_dropdown_jsx(ClickAwayListener_default.a, {
      onClickAway: handleClose.bind(order_dropdown_this)
    }, order_dropdown_jsx(MenuList_default.a, null, orderFilters.map(function (item) {
      return order_dropdown_jsx(MenuItem_default.a, {
        key: item.value,
        onClick: function onClick() {
          return onOptionChange(item.value);
        }
      }, item.label);
    })))));
  }));
};

order_dropdown_OrderDropdownE6t.defaultProps = {
  classes: {},
  criteria: {}
};
/* harmony default export */ var order_dropdown = (Object(styles["withStyles"])(order_dropdown_styles)(order_dropdown_OrderDropdownE6t));
// EXTERNAL MODULE: ./src/components/e6t/common-filters/filter-bar/index.jsx + 2 modules
var filter_bar = __webpack_require__("5NJ2");

// EXTERNAL MODULE: ./src/components/desktop/common/header/index.jsx + 20 modules
var header = __webpack_require__("VEIF");

// EXTERNAL MODULE: ./src/components/desktop/common/content/index.jsx
var content = __webpack_require__("LmzW");

// EXTERNAL MODULE: ./src/components/desktop/common/footer/social-bar/index.js + 1 modules
var social_bar = __webpack_require__("kSbz");

// EXTERNAL MODULE: ./src/components/desktop/common/footer/index.js + 1 modules
var footer = __webpack_require__("PhnI");

// EXTERNAL MODULE: ./src/components/desktop/common/footer/footer-categories/index.js
var footer_categories = __webpack_require__("HIAB");

// EXTERNAL MODULE: ./src/components/desktop/common/footer/ilab-footer/index.js + 1 modules
var ilab_footer = __webpack_require__("6lYI");

// EXTERNAL MODULE: ./src/helpers/google-tag-manager/scroll-bound/agent-detail.js
var agent_detail = __webpack_require__("MGGQ");
var agent_detail_default = /*#__PURE__*/__webpack_require__.n(agent_detail);

// EXTERNAL MODULE: ./src/helpers/google-tag-manager/set-search-id.js
var set_search_id = __webpack_require__("P2Yd");
var set_search_id_default = /*#__PURE__*/__webpack_require__.n(set_search_id);

// EXTERNAL MODULE: ./src/helpers/google-tag-manager/gtm-load-interval.js
var gtm_load_interval = __webpack_require__("akS8");

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/PhoneOutlined.js
var PhoneOutlined = __webpack_require__("bPl8");
var PhoneOutlined_default = /*#__PURE__*/__webpack_require__.n(PhoneOutlined);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LocationOnOutlined.js
var LocationOnOutlined = __webpack_require__("tPG/");
var LocationOnOutlined_default = /*#__PURE__*/__webpack_require__.n(LocationOnOutlined);

// EXTERNAL MODULE: ./node_modules/@emlakjet/commons/helpers/phone-number/index.js
var phone_number = __webpack_require__("BM/k");

// EXTERNAL MODULE: ./src/components/desktop/document-no-card/index.jsx
var document_no_card = __webpack_require__("Lojg");

// EXTERNAL MODULE: ./src/app/desktop/agent-page/header/styles.module.scss
var header_styles_module = __webpack_require__("N8g/");
var header_styles_module_default = /*#__PURE__*/__webpack_require__.n(header_styles_module);

// CONCATENATED MODULE: ./src/app/desktop/agent-page/header/index.jsx

var header_jsx = react_default.a.createElement;









var header_AccountPageHeader = function AccountPageHeader(_ref) {
  var _classnames, _classnames2, _classnames3, _classnames4;

  var accountInfo = _ref.accountInfo;
  var account = accountInfo.account;
  var member = accountInfo.member;
  var isCorporate = account.type === 'CORPORATE';
  var accountDocument = accountInfo.accountDocument;
  var membershipType = account.membershipType;
  var membershipTypePrestige = membershipType === 'prestige' || membershipType === 'prestige plus';
  var membershipTypePlatinum = membershipType === 'platinum' || membershipType === 'platinum plus';
  var documentNo = accountDocument ? accountDocument.no : null;

  var accountCoverPhoto = function accountCoverPhoto() {
    if (membershipTypePrestige) return 'emlak-ofisi-premium.jpg';
    if (membershipType === 'platinum plus') return 'emlak-ofisi-platinum-plus.png';
    if (membershipTypePlatinum) return 'emlak-ofisi-platinum.png';
    return 'emlak-ofisi-photo.jpg';
  };

  var ownerDurationContainer = classnames_default()((_classnames = {}, Object(defineProperty["default"])(_classnames, header_styles_module_default.a.ownerDurationContainer, true), Object(defineProperty["default"])(_classnames, header_styles_module_default.a.ownerDurationWithOutDocument, !documentNo), Object(defineProperty["default"])(_classnames, header_styles_module_default.a.ownerDurationContainerPlatinum, membershipTypePlatinum), _classnames));
  var wrapperClasses = classnames_default()((_classnames2 = {}, Object(defineProperty["default"])(_classnames2, header_styles_module_default.a.accountBox, true), Object(defineProperty["default"])(_classnames2, header_styles_module_default.a.accountBoxPlatinum, membershipTypePlatinum), _classnames2));
  var phoneboxClasses = classnames_default()((_classnames3 = {}, Object(defineProperty["default"])(_classnames3, header_styles_module_default.a.phoneBox, true), Object(defineProperty["default"])(_classnames3, header_styles_module_default.a.phoneBoxPlatinum, membershipTypePlatinum), _classnames3));
  var platinumIconClassess = classnames_default()((_classnames4 = {}, Object(defineProperty["default"])(_classnames4, header_styles_module_default.a.platinumIcon, true), Object(defineProperty["default"])(_classnames4, header_styles_module_default.a.platinumIconWide, membershipType === 'platinum plus'), _classnames4));

  var convertJethatNumber = function convertJethatNumber(jethatNumber) {
    if (jethatNumber) {
      if (jethatNumber.startsWith('+90')) {
        return jethatNumber.split('+90')[1];
      }

      return jethatNumber;
    }

    return null;
  };

  if (!accountInfo) {
    return header_jsx("div", {
      className: header_styles_module_default.a.wrapper,
      style: {
        backgroundImage: "url(/static/img/".concat(accountCoverPhoto(), ")"),
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }
    }, header_jsx("div", {
      className: header_styles_module_default.a.inlineWrapper
    }));
  }

  var corporateView = function corporateView() {
    var jethatNumber = convertJethatNumber(account.phoneNumber);
    var formattedJetHat = Object(phone_number["formatJetHat"])(jethatNumber).replace(/(\d)(\d\d\d)(\d\d\d)(\d\d\d\d)/, '$1 ($2) $3 $4');
    var location = account.address ? account.address : '';
    var logoUrl = image_url_maker["a" /* default */].scaleImage(account.logo, {
      width: 240,
      height: 150
    });
    return header_jsx(react_default.a.Fragment, null, header_jsx("div", {
      className: wrapperClasses
    }, header_jsx("div", {
      className: header_styles_module_default.a.logoWrapper
    }, header_jsx("img", {
      src: logoUrl,
      className: header_styles_module_default.a.logo,
      alt: account.name
    })), header_jsx("div", {
      className: header_styles_module_default.a.accountInfoWrapper
    }, membershipTypePrestige && header_jsx(react_default.a.Fragment, null, header_jsx("div", {
      className: header_styles_module_default.a.memberIcon
    }, header_jsx("i", {
      style: {
        backgroundImage: membershipType === 'prestige' ? 'url(/static/icons/icon_prestige.svg)' : 'url(/static/icons/icon_prestigeplus.svg)'
      },
      className: header_styles_module_default.a.prestigeIcon
    }))), membershipTypePlatinum && header_jsx(react_default.a.Fragment, null, header_jsx("div", {
      className: header_styles_module_default.a.platinumInfoWrap
    }, header_jsx("div", {
      className: header_styles_module_default.a.platinumIconWrap
    }, header_jsx("i", {
      style: {
        backgroundImage: membershipType === 'platinum' ? 'url(/static/icons/icon_platinum.svg)' : 'url(/static/icons/icon_platinumplus.svg)'
      },
      className: platinumIconClassess
    })), header_jsx("div", {
      className: ownerDurationContainer
    }, header_jsx("img", {
      src: "/static/img/duration-of-membership-platinum.svg",
      alt: "duration-of-membership"
    }), header_jsx("span", {
      className: header_styles_module_default.a.ownerDurationYear
    }, "".concat(account.durationOfMembership, ".")), header_jsx("span", {
      className: header_styles_module_default.a.ownerDurationText
    }, "YIL")))), membershipType === 'premium' && header_jsx("div", {
      className: header_styles_module_default.a.memberPremium
    }, header_jsx("span", null, "PREM\u0130UM \xDCYE")), header_jsx("h1", {
      className: header_styles_module_default.a.name
    }, account.name), header_jsx("div", {
      className: header_styles_module_default.a.locationWrapper
    }, header_jsx(LocationOnOutlined_default.a, {
      className: header_styles_module_default.a.locationIcon
    }), header_jsx("p", {
      className: header_styles_module_default.a.location
    }, location)), account.durationOfMembership > 0 && !membershipTypePlatinum && header_jsx("div", {
      className: ownerDurationContainer
    }, header_jsx("img", {
      src: "/static/img/duration-of-membership.svg",
      alt: "duration-of-membership"
    }), header_jsx("span", {
      className: header_styles_module_default.a.ownerDurationYear
    }, "".concat(account.durationOfMembership, ".")), header_jsx("span", {
      className: header_styles_module_default.a.ownerDurationText
    }, "YIL")))), header_jsx("div", {
      className: phoneboxClasses
    }, header_jsx("div", {
      className: header_styles_module_default.a.phoneIconWrapper
    }, header_jsx("div", {
      className: header_styles_module_default.a.contactWrapper
    }, header_jsx("p", {
      className: header_styles_module_default.a.contactName
    }, member.name), header_jsx("p", {
      className: header_styles_module_default.a.contactPhone
    }, formattedJetHat)), header_jsx("div", {
      className: header_styles_module_default.a.phoneIconBox
    }, header_jsx(PhoneOutlined_default.a, {
      className: header_styles_module_default.a.phoneIcon
    })), header_jsx("div", {
      className: header_styles_module_default.a.documentCardWrap
    }, header_jsx(document_no_card["a" /* default */], {
      cardDirection: "column",
      transparent: true,
      accountDocumentNo: documentNo
    })))));
  };

  var individualView = function individualView() {
    return header_jsx(react_default.a.Fragment, null, header_jsx("div", {
      className: header_styles_module_default.a.contactWrapper
    }, header_jsx("p", {
      className: header_styles_module_default.a.contactName
    }, member.name)), header_jsx("div", {
      className: header_styles_module_default.a.phoneIconWrapper
    }, header_jsx(PhoneOutlined_default.a, {
      className: header_styles_module_default.a.phoneIcon
    })));
  };

  return header_jsx("div", {
    className: header_styles_module_default.a.wrapper,
    style: {
      backgroundImage: "url(/static/img/".concat(accountCoverPhoto(), ")"),
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    }
  }, header_jsx("div", {
    className: header_styles_module_default.a.inlineWrapper
  }, isCorporate ? corporateView() : individualView()));
};

/* harmony default export */ var agent_page_header = (header_AccountPageHeader);
// EXTERNAL MODULE: ./src/app/desktop/agent-page/styles.module.scss
var agent_page_styles_module = __webpack_require__("uf3P");
var agent_page_styles_module_default = /*#__PURE__*/__webpack_require__.n(agent_page_styles_module);

// CONCATENATED MODULE: ./src/app/desktop/agent-page/index.jsx






var agent_page_jsx = react_default.a.createElement;

function agent_page_createSuper(Derived) { var hasNativeReflectConstruct = agent_page_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function agent_page_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable react/jsx-one-expression-per-line */








 // java


















var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var agent_page_AgentDetailPage = /*#__PURE__*/function (_React$Component) {
  Object(inherits["a" /* default */])(AgentDetailPage, _React$Component);

  var _super = agent_page_createSuper(AgentDetailPage);

  function AgentDetailPage(props) {
    var _this;

    Object(classCallCheck["a" /* default */])(this, AgentDetailPage);

    _this = _super.call(this, props);
    var accountInfo = _this.props.pageResponse.accountInfo;
    _this.accountState = lodash_default.a.get(accountInfo, 'account.state', undefined);
    _this.isPassiveAgent = _this.accountState && _this.accountState === 'PASSIVE';
    return _this;
  }

  Object(createClass["a" /* default */])(AgentDetailPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          pageResponse = _this$props.pageResponse,
          pageName = _this$props.pageName;
      var accountData = pageResponse.accountData;

      var listings = lodash_default.a.get(accountData, 'listingCard.records', []);

      var _ref = accountData || {},
          searchCriteria = _ref.searchCriteria;

      var pageNumber = lodash_default.a.get(searchCriteria, 'pagination.page', {});

      var _this$props2 = this.props,
          fetchAllFavoriteList = _this$props2.fetchAllFavoriteList,
          isAuth = _this$props2.isAuth;
      this.isPassiveAgent && Object(notifier["a" /* default */])('Bu emlakçıya ulaşılamıyor', 'error', 3000);

      if (isAuth) {
        fetchAllFavoriteList();
      } // gtm activity running in agent detail


      set_search_id_default()(pageName).then(function (result) {
        Object(events["M" /* pageInitialGTMEvent */])(result, 'emlak-ofisi-detay');
      });
      Object(gtm_load_interval["a" /* gtmLoadInterval */])(function () {
        agent_detail_default()(listings, pageNumber);
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props3 = this.props,
          fetchAllFavoriteList = _this$props3.fetchAllFavoriteList,
          isAuth = _this$props3.isAuth;

      if (nextProps.isAuth === true && nextProps.isAuth !== isAuth) {
        fetchAllFavoriteList();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var isAuth = this.props.isAuth;

      if (nextProps.isAuth && isAuth !== nextProps.isAuth) {
        return true;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var pageResponse = this.props.pageResponse;
      var accountInfo = pageResponse.accountInfo,
          accountData = pageResponse.accountData;

      var _ref2 = accountData || {},
          url = _ref2.url,
          maximumPage = _ref2.maximumPage;

      var accountName = Object(capitalize_letter["a" /* default */])(lodash_default.a.get(accountInfo, 'account.name', ''));
      var accountAddress = Object(capitalize_letter["a" /* default */])(lodash_default.a.get(accountInfo, 'account.address', ''));
      var accountLocation = accountAddress && accountAddress.includes(',') ? accountAddress.replace(',', ' -') : '';

      var listingArray = lodash_default.a.get(accountData, 'listingCard.records', []);

      var total = lodash_default.a.get(accountData, 'listingCard.total', 0);

      var criteria = lodash_default.a.get(accountData, 'searchCriteria', {});

      var pagination = lodash_default.a.get(accountData, 'searchCriteria.pagination', {});

      var page = (pagination === null || pagination === void 0 ? void 0 : pagination.page) || 1;
      var maxPage = maximumPage || 1;
      var pageSuffix = (pagination === null || pagination === void 0 ? void 0 : pagination.page) > 1 ? " - Sayfa ".concat(pagination === null || pagination === void 0 ? void 0 : pagination.page) : "";
      var descriptionContent = "".concat(accountName, " Emlak Ofisi ilanlar\u0131n\u0131 hemen inceleyin! ").concat(accountName, " - ").concat(accountLocation, " Kiral\u0131k - Sat\u0131l\u0131k \u0130lanlar\u0131 Emlakjet.com'da!").concat(pageSuffix);
      var titleContent = "".concat(accountName, " - ").concat(accountLocation, " Emlak Ofisi \u0130lanlar\u0131").concat(pageSuffix);
      var ogTitleContent = "".concat(accountName, " Emlak Ofisi \u0130lanlar\u0131 - Emlakjet").concat(pageSuffix);

      var buildPageUrl = function buildPageUrl(urlObj, pageNumber) {
        var _urlObj$queryParams;

        var params = new URLSearchParams(((_urlObj$queryParams = urlObj.queryParams) === null || _urlObj$queryParams === void 0 ? void 0 : _urlObj$queryParams.replace('?', '')) || '');

        if (pageNumber === 1) {
          params["delete"]('sayfa');
        } else {
          params.set('sayfa', pageNumber);
        }

        var queryString = params.toString();
        return "".concat(publicRuntimeConfig.app.hostname).concat(urlObj.basePath).concat(queryString ? "?".concat(queryString) : '');
      };

      var listingsDiv = agent_page_jsx("div", {
        className: agent_page_styles_module_default.a.contentWrapper
      }, agent_page_jsx(content["a" /* default */], null, agent_page_jsx("div", {
        className: agent_page_styles_module_default.a.title
      }, agent_page_jsx("span", {
        className: agent_page_styles_module_default.a.header
      }, total ? agent_page_jsx(react_default.a.Fragment, null, agent_page_jsx("h2", null, accountName, " \u0130lanlar\u0131"), agent_page_jsx("span", null, "(", total, " \u0130lan)")) : agent_page_jsx("p", null, "Bu Emlak Ofisinin kriterlerinize uygun ilan\u0131 bulunmuyor")), total ? agent_page_jsx(order_dropdown, {
        criteria: criteria,
        buttonType: "showcase"
      }) : null), agent_page_jsx("div", {
        className: agent_page_styles_module_default.a.flexRow,
        id: "agent-detail-wrapper"
      }, Array.isArray(listingArray) && listingArray.map(function (listing, index) {
        return agent_page_jsx("div", {
          className: agent_page_styles_module_default.a.gridColumn,
          key: shortid_default.a.generate(),
          "data-index": index
        }, agent_page_jsx(featured_listing_item_search, {
          key: listing.id,
          listing: listing,
          itemIndex: index,
          gtmEventLabel: "emlak-ofisi-detay",
          pageNumber: pagination === null || pagination === void 0 ? void 0 : pagination.page
        }));
      })), total > 0 && agent_page_jsx(pagination_wrapper_e6t["a" /* default */], {
        url: url,
        maximumPage: maximumPage,
        pagination: pagination,
        totalListingCount: total,
        isAgentPage: true,
        paginationTitle: accountName
      })));

      return agent_page_jsx(react_default.a.Fragment, null, agent_page_jsx(head_default.a, null, agent_page_jsx("title", null, titleContent), agent_page_jsx("meta", {
        name: "og:title",
        content: ogTitleContent
      }), agent_page_jsx("meta", {
        name: "description",
        content: descriptionContent
      }), agent_page_jsx("meta", {
        name: "og:description",
        content: descriptionContent
      }), agent_page_jsx("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1.0"
      }), (url === null || url === void 0 ? void 0 : url.canonicalPath) && agent_page_jsx("link", {
        rel: "canonical",
        href: "".concat(publicRuntimeConfig.app.hostname).concat(url.canonicalPath)
      }), agent_page_jsx("meta", {
        name: "robots",
        content: "max-image-preview:large"
      }), page > 1 && agent_page_jsx("link", {
        rel: "prev",
        href: buildPageUrl(url, page - 1)
      }), page < maxPage && agent_page_jsx("link", {
        rel: "next",
        href: buildPageUrl(url, page + 1)
      })), agent_page_jsx(header["a" /* default */], {
        small: true
      }), !this.isPassiveAgent ? agent_page_jsx(react_default.a.Fragment, null, agent_page_jsx(agent_page_header, {
        accountInfo: accountInfo
      }), listingsDiv) : agent_page_jsx("div", {
        className: agent_page_styles_module_default.a.passiveAgentInfo
      }, agent_page_jsx("a", {
        href: "/"
      }, agent_page_jsx("img", {
        src: "/static/img/logo.svg",
        alt: "Emlakjet",
        height: "39"
      })), agent_page_jsx("p", null, "Arad\u0131\u011F\u0131n\u0131z emlak\xE7\u0131 bulunamad\u0131.")), agent_page_jsx(social_bar["a" /* default */], null), agent_page_jsx(footer_categories["a" /* default */], null), agent_page_jsx(footer["a" /* default */], null), agent_page_jsx(ilab_footer["a" /* default */], null));
    }
  }]);

  return AgentDetailPage;
}(react_default.a.Component);

/* harmony default export */ var agent_page = (es["b" /* connect */].apply(void 0, Object(toConsumableArray["a" /* default */])(favorites["a" /* default */]))(agent_page_AgentDetailPage));
// CONCATENATED MODULE: ./pages/account-detail.jsx


var account_detail_jsx = react_default.a.createElement;






var account_detail_AgentPage = function AgentPage(_ref) {
  var pageResponse = _ref.pageResponse,
      pageName = _ref.pageName;
  return account_detail_jsx(agent_page, {
    pageResponse: pageResponse,
    pageName: pageName
  });
};

account_detail_AgentPage.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(_ref2) {
    var _pageResponse$account;

    var res, req, asPath, query, accountId, pageName, sayfa, url, parsedUrl, newUrl, promise, pageResponse, maxPage, currentPage, _newUrl;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            res = _ref2.res, req = _ref2.req, asPath = _ref2.asPath, query = _ref2.query;
            accountId = query.accountId, pageName = query.pageName, sayfa = query.sayfa;
            url = req.url;
            parsedUrl = new URL(req.url, "https://".concat(req.headers.host));

            if (!(sayfa === '1' && res)) {
              _context.next = 8;
              break;
            }

            parsedUrl.searchParams["delete"]('sayfa');
            newUrl = parsedUrl.pathname + parsedUrl.search;
            return _context.abrupt("return", res.redirect(301, newUrl));

          case 8:
            promise = new Promise(function (resolve) {
              async_default.a.parallel([// get agent info items
              async_default.a.reflect(function (callback) {
                Object(services_account["a" /* getAccountDetail */])(accountId).then(function (response) {
                  if (response.status !== 'success') {
                    callback(response.toString());
                  } else {
                    callback(null, response.result);
                  }
                })["catch"](function (err) {
                  // errors with response codes 4xx, 5xx etc.
                  callback({
                    message: err.toString()
                  });
                });
              }), // get detail data
              async_default.a.reflect(function (callback) {
                Object(services_account["b" /* getAccountDetailPageData */])(url).then(function (response) {
                  callback(response);
                })["catch"](function (err) {
                  // errors with response codes 4xx, 5xx etc.
                  callback({
                    message: err.toString()
                  });
                });
              })], function (err, results) {
                // eslint-disable-next-line no-use-before-define
                var accountResult = results[0].value.account;

                if (!isValidAgentUrl(asPath, accountResult)) {
                  res.redirect(301, (accountResult === null || accountResult === void 0 ? void 0 : accountResult.url.charAt(url - 1)) !== '/' ? "".concat(accountResult === null || accountResult === void 0 ? void 0 : accountResult.url, "/") : accountResult === null || accountResult === void 0 ? void 0 : accountResult.url);
                } else if (accountResult.state === 'PASSIVE') {
                  res.redirect(302, "/emlak-ofisleri/");
                }

                var response = {
                  accountInfo: results[0].value,
                  accountData: results[1].error
                };
                resolve(response);
              });
            });
            _context.next = 11;
            return promise;

          case 11:
            pageResponse = _context.sent;

            if (!(res && sayfa && (pageResponse === null || pageResponse === void 0 ? void 0 : (_pageResponse$account = pageResponse.accountData) === null || _pageResponse$account === void 0 ? void 0 : _pageResponse$account.maximumPage))) {
              _context.next = 19;
              break;
            }

            maxPage = parseInt(pageResponse.accountData.maximumPage);
            currentPage = parseInt(sayfa);

            if (!(currentPage > maxPage)) {
              _context.next = 19;
              break;
            }

            parsedUrl.searchParams["delete"]('sayfa');
            _newUrl = parsedUrl.pathname + parsedUrl.search;
            return _context.abrupt("return", res.redirect(301, _newUrl));

          case 19:
            return _context.abrupt("return", {
              pageResponse: pageResponse,
              pageName: pageName
            });

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

/* harmony default export */ var account_detail = __webpack_exports__["default"] = (account_detail_AgentPage);

/***/ }),

/***/ "6Llf":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account-detail",
      function () {
        return __webpack_require__("5adZ");
      }
    ]);
  

/***/ }),

/***/ "HIAB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _footer_categories__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("V+Py");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _footer_categories__WEBPACK_IMPORTED_MODULE_0__["a"]; });



/***/ }),

/***/ "Lojg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentNoCard; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("/svJ");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement;



function DocumentNoCard(_ref) {
  var _classNames, _classNames2, _classNames3;

  var memberDocumentNo = _ref.memberDocumentNo,
      accountDocumentNo = _ref.accountDocumentNo,
      className = _ref.className,
      titleClassName = _ref.titleClassName,
      tooltipArrowPosition = _ref.tooltipArrowPosition,
      containerDirection = _ref.containerDirection,
      cardDirection = _ref.cardDirection,
      transparent = _ref.transparent,
      tooltipSpace = _ref.tooltipSpace,
      accountType = _ref.accountType;
  var rootClassnames = classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a[containerDirection], className, (_classNames = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames, _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.root, accountType !== 'PERSONAL'), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames, _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.transparent, transparent), _classNames));
  var titleClassNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_classNames2 = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames2, _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.title, true), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames2, _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.bothDocumentHave, accountDocumentNo && memberDocumentNo), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames2, titleClassName, true), _classNames2));
  var tooltipPositon = classnames__WEBPACK_IMPORTED_MODULE_2___default()((_classNames3 = {}, Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames3, _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.tooltip, true), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames3, _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a[tooltipArrowPosition], tooltipArrowPosition), Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_classNames3, _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.tooltipSpace, tooltipSpace), _classNames3));
  var cardContainer = classnames__WEBPACK_IMPORTED_MODULE_2___default()(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a[cardDirection], Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.card, true));
  return __jsx("div", {
    className: rootClassnames
  }, __jsx("div", {
    className: cardContainer
  }, accountDocumentNo && __jsx(react__WEBPACK_IMPORTED_MODULE_1___default.a.Fragment, null, __jsx("span", {
    className: titleClassNames
  }, "Ta\u015F\u0131nmaz Ticareti Yetki Belgesi:"), __jsx("span", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.no
  }, accountDocumentNo)), !accountDocumentNo && accountType !== 'PERSONAL' && __jsx("span", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.noDocumentTitle
  }, "Ta\u015F\u0131nmaz Ticareti Yetki Belge Bilgileri Girilmemi\u015Ftir")), memberDocumentNo && __jsx("div", {
    className: cardContainer
  }, __jsx("span", {
    className: titleClassNames
  }, "Yeterlilik Belgesi:"), __jsx("span", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.no
  }, memberDocumentNo)), accountType !== 'PERSONAL' && __jsx("img", {
    src: "/static/icons/round-info.svg",
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.roundIcon,
    alt: "round-info"
  }), __jsx("img", {
    src: "/static/icons/round-info-owner.svg",
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.roundIconOwner,
    alt: "round-info"
  }), __jsx("div", {
    className: tooltipPositon
  }, __jsx("span", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default.a.tooltipContent
  }, "5 Haziran 2018 tarihinde Resmi Gazete\u2019de yay\u0131mlanan y\xFCr\xFCrl\xFC\u011Fe g\xF6re ta\u015F\u0131nmaz\u0131n al\u0131m, sat\u0131m ve kiralama i\u015Flemine arac\u0131l\u0131k eden firmalar\u0131n Ta\u015F\u0131nmaz Ticaret Yetki Belgesine sahip olmas\u0131 ve yine arac\u0131l\u0131k eden ki\u015Filerin Mesleki Yeterlilik Belgesi sahibi olmas\u0131 zorunlulu\u011Fu getirildi.")));
}
DocumentNoCard.defaultProps = {
  className: '',
  titleClassName: '',
  memberDocumentNo: null,
  accountDocumentNo: null,
  containerDirection: 'row',
  cardDirection: 'row',
  tooltipArrowPosition: 'left',
  transparent: false,
  tooltipSpace: false
};

/***/ }),

/***/ "MGGQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _listingDetail = __webpack_require__("UYDH");

var debounceTimer;
var sentItems = [];
var virtualState = [];

var debounce = function debounce(callback, time) {
  window.clearTimeout(debounceTimer);
  debounceTimer = window.setTimeout(callback, time);
};

var prepareData = function prepareData(items, listings, pageNumber) {
  debounce(function () {
    items.forEach(function (item, index) {
      if (item.getBoundingClientRect().top - window.innerHeight < 0 && !sentItems.includes(index)) {
        virtualState.push(item.dataset.index);
      }
    });
    sentItems.push(virtualState);

    if (virtualState.length > 0) {
      (0, _listingDetail.agentPageDetailListingViewed)(listings.filter(function (item, index) {
        return index >= virtualState[0] && index <= virtualState[virtualState.length - 1];
      }), virtualState, pageNumber);
    }

    virtualState = [];
  }, 250);
};

var agentDetailScrollGTMEvents = function agentDetailScrollGTMEvents(listings, pageNumber) {
  var wrapper = document.getElementById('agent-detail-wrapper');

  if (wrapper) {
    var items = wrapper.querySelectorAll('[data-index]');

    if (items.length > 0) {
      window.addEventListener('scroll', function () {
        prepareData(items, listings, pageNumber);
      }, false);
      window.addEventListener('load', function () {
        prepareData(items, listings, pageNumber);
      });
    }
  }
};

module.exports = agentDetailScrollGTMEvents;

/***/ }),

/***/ "N8g/":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2Wyr-3","inlineWrapper":"_1tknRk","logoWrapper":"_2euntR","logo":"HZetJd","accountInfoWrapper":"Zfvwe4","name":"_1hJnvU","accountBoxPlatinum":"_3hxgMo","locationWrapper":"_1bKjqH","ownerDurationContainer":"_1Gk73v","ownerDurationYear":"_-6nRo6","ownerDurationContainerPlatinum":"_1X3qDS","ownerDurationText":"ixNq-Z","ownerDurationWithOutDocument":"CEAxs6","location":"_3ULzaX","locationIcon":"_1y__uN","phoneIconWrapper":"_3jqrsz","phoneIcon":"MGG9BR","phoneIconBox":"_36ogjO","contactWrapper":"DrcKet","contactName":"_1B7CNy","contactPhone":"_1kJ78y","memberIcon":"jQXS3I","prestigeIcon":"_323Oat","platinumIcon":"_3_Npm7","platinumIconWide":"_3jAHPs","memberPremium":"ke2PaY","phoneBox":"_3Xc80l","accountBox":"_1N1f1h","platinumInfoWrap":"_23MyTt","platinumIconWrap":"_1wXndO","phoneBoxPlatinum":"_35DG6H","documentCardWrap":"_38lovo"};

/***/ }),

/***/ "OXD+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var transformCapitalizeLetter = function transformCapitalizeLetter(str) {
  if (typeof str !== 'string') return null;
  if (!str) return '';
  return str.replace(/(\S)(\S*)/g, function (_, firstLetter, restOfWord) {
    return firstLetter.toLocaleUpperCase('tr') + restOfWord.toLocaleLowerCase('tr');
  });
};

/* harmony default export */ __webpack_exports__["a"] = (transformCapitalizeLetter);

/***/ }),

/***/ "YAe4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"_2_RcxW","featuredListing":"_3GddZw","featuredListingWrapperButtons":"_3zc-j6","featuredListingWrapper":"_1R_ZGm","listingImageContent":"_2EubJ_","listingDetail":"_3frxVT","listingDetailTitle":"_1Thxvk","listingDetailAdress":"_3WrsOp","listingDetailProperties":"_1VjVSs","listingDetailPriceAndDate":"_1jXjjM","price":"_26rM8y","date":"_3EV7mN","badges":"_1CFsq-"};

/***/ }),

/***/ "akS8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtmLoadInterval; });
var gtmLoadInterval = function gtmLoadInterval(callback) {
  var interval = setInterval(function () {
    window.dataLayer = window.dataLayer || [];

    if (window.dataLayer.filter(function (x) {
      return x.event === 'gtm.load';
    }).length > 0) {
      callback();
      clearInterval(interval);
    }
  }, 1000);
};

/***/ }),

/***/ "bPl8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _createSvgIcon = _interopRequireDefault(__webpack_require__("8/g6"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1z"
}))), 'PhoneOutlined');

exports.default = _default;

/***/ }),

/***/ "tPG/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _createSvgIcon = _interopRequireDefault(__webpack_require__("8/g6"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("g", null, _react.default.createElement("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"
}), _react.default.createElement("circle", {
  cx: "12",
  cy: "9",
  r: "2.5"
}))), 'LocationOnOutlined');

exports.default = _default;

/***/ }),

/***/ "uf3P":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"_a2dLW","title":"_3yFGrd","header":"_2FLeV_","flexRow":"NvmgZq","gridColumn":"_3tmFAp","listingCount":"_3AyEJg","passiveAgentInfo":"_25NdVS"};

/***/ })

},[["6Llf",1,2,3,16,0,4,5,6,7,8,9,10,11,12,13,20,31]]]);